import React, { FC }                     from 'react';
import { formatOption }                  from '../../../../util';
import { SelectField, SelectFieldProps } from '../../../components/forms';
import { CONDITION_TYPES }               from '../../../../constants/SystemEnums';
import { PreSelectedSelectField }        from '../../../../types';

const ConditionTypeDropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( CONDITION_TYPES.CONTAINS, 'Contains' ),
		formatOption( CONDITION_TYPES.NOT_CONTAINS, 'Does not contain' ),
		formatOption( CONDITION_TYPES.EQUALTO, 'Equals' ),
		formatOption( CONDITION_TYPES.NOT_EQUALTO, 'Does not equal' ),
		formatOption( CONDITION_TYPES.GREATERTHAN, 'Is greater than' ),
		formatOption( CONDITION_TYPES.LESSTHAN, 'Is less than' ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

const IsOrNotDropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	return (
		<ConditionTypeDropdown
			dictionary={ new Map( [
				[ CONDITION_TYPES.EQUALTO, 'Is' ],
				[ CONDITION_TYPES.NOT_EQUALTO, 'Is Not' ],
			] ) }
			only={ [
				CONDITION_TYPES.EQUALTO,
				CONDITION_TYPES.NOT_EQUALTO,
			] }
			{ ...props }/>
	)
};

export { ConditionTypeDropdown };
export { IsOrNotDropdown };
